import { YesObject } from '@yes.technology/react-toolkit'
import uniqBy from 'lodash/uniqBy'
import { useEffect, useMemo, useState } from 'react'

const useRelationClassLocalRelationState = (
  currentRelationFromParent: YesObject[],
  isEditing: boolean
) => {
  const [unsavedObjects, setUnsavedObjects] = useState<YesObject[]>([])
  const [savedObjectsToRemove, setSavedObjectsToRemove] = useState<YesObject[]>(
    []
  )

  const relationWorkingSet = useMemo(
    () => uniqBy([...currentRelationFromParent, ...unsavedObjects], 'uuid'),
    [currentRelationFromParent, unsavedObjects]
  )

  useEffect(() => {
    if (!isEditing && savedObjectsToRemove.length) {
      setSavedObjectsToRemove([])
    }
  }, [isEditing, savedObjectsToRemove.length])

  return {
    unsavedObjects,
    setUnsavedObjects,
    savedObjectsToRemove,
    setSavedObjectsToRemove,
    relationWorkingSet
  }
}

export default useRelationClassLocalRelationState
